import styles from '@/styles/components/controls/Checkbox.module.scss'
import { forwardRef } from 'react'
import cn from 'classnames'

interface Props {
  label: string,
  error?: string,
  showError?: boolean,
  name?: string
  valid?: boolean,
  invalid?: boolean,
  fontSize?: number,
  dark?: boolean,
  className?: string,
  value?: string | number | readonly string[] | undefined,
  onChange?: (event: {
    target: any
    type?: any
  }) => Promise<void | boolean>
  onBlur?: (event: {
    target: any
    type?: any
  }) => Promise<void | boolean>
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(({
  label,
  className = '',
  error,
  showError = true,
  valid,
  value = undefined,
  name,
  dark = true,
  fontSize,
  onChange,
  onBlur
}, ref) => {
  const controlClasses = cn({
    [styles.control_checkbox]: true,
  })

  const labelClasses = cn({
    [styles.control_checkbox_label]: true,
    [styles.control_checkbox_label_light]: !dark,
  })

  const inputClasses = cn({
    [styles.control_checkbox_input]: true,
  })

  const checkmarkClasses = cn({
    [styles.control_checkbox_checkmark]: true,
    [styles.control_checkbox_checkmark_light]: !dark,
    [styles.control_checkbox_checkmark_invalid]: !!error,
    [styles.control_checkbox_checkmark_valid]: valid
  })

  return (
    <div className={`${controlClasses} ${className}`}>
      <label style={{fontSize: fontSize ? fontSize + 'px' : undefined}} className={labelClasses}>{label}
        <input type='checkbox' className={inputClasses} onChange={onChange} value={value} onBlur={onBlur} name={name} ref={ref} />
        <span className={checkmarkClasses}></span>
      </label>
      {error && showError && <span className={styles.control_checkbox_error}>{error}</span>}
    </div>
  )
})

Checkbox.displayName = 'Checkbox'
